import React from 'react';
import { Modal } from './Modal';
interface ShowMoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function ShowMoreModal({
  isOpen,
  onClose,
  title,
  children
}: ShowMoreModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title={title} maxWidth="lg" data-id="element-780">
      <div className="max-h-[60vh] overflow-y-auto -mx-2 px-2" data-id="element-781">{children}</div>
    </Modal>;
}